export class Constant {
 // public static BaseUrl = '/api'
 //public static BaseUrl = 'https://bajajuat.bajajallianz.com/'  //  new preprod
  //public static BaseUrl = 'https://bajajallianzlifeonline.co.in/'  // Production URL's=
  // public static BaseUrl = 'https://balicuat.bajajallianz.com/' //UAT 6
 //public static BaseUrl = 'https://balicuat2.bajajallianzlife.com/' //UAT 1,2,3,4,5
  public static BaseUrl = 'https://balicuat4.bajajallianzlife.com/' //UAT 1,2,3,4,5
  //public static BaseUrl = 'http://10.3.4.95/' //UAT 5
  // public static BaseUrl = 'http://10.3.40.144/' //Infi UAT 
  //public static BaseUrl = 'http://10.3.4.38/'  /*Prepod*/


  //*******uncomment the Prod key with uat key when creating prod version ****** 
  //production 
  // public static RAZORPY_KEY = 'rzp_live_X9BnXev7IfukgC';   //prod
  // public static createCustomer  = 'https://payment.baliconline.in/BackOfficeScheduler/rozarpaymandate/createcustomer';
  // public static saveMandateSign= 'https://payment.baliconline.in/BackOfficeScheduler/rozarpaymandate/mandatesignature';
  // public static downTimeUrl = "https://payment.baliconline.in/BackOfficeScheduler/util/mandate_downtime";
  // public static vendorType = 'https://payment.baliconline.in/BackOfficeScheduler/util/mandate_pg';
  // public static renPayModeChange = "https://payment.baliconline.in/BackOfficeScheduler/util/updatedPayMode";
  // public static ccsi='https://payment.baliconline.in/BalicPayment/ccsi/PG.jsp';
  // public static NRIccsi="https://payment.baliconline.in/CCSI/initiate/payment";
  // public static NRIccsiCallbackURL="https://payment.baliconline.in/BalicPayment/ccsi/ccsiNRIResponseHandler.jsp";
  // public static validateUPIAgent = 'https://payment.baliconline.in/CCSI/mandate/validateAgentCode';
  // public static vendorTypeUPI = 'https://payment.baliconline.in/BackOfficeScheduler/rozarpayUPImandate/upi_mandate_pg';
  // public static vendorTypeNACH = 'https://payment.baliconline.in/BackOfficeScheduler/rozarpayUPImandate/nach_mandate_pg';
  // public static vendorTypeCCSI = 'https://payment.baliconline.in/BackOfficeScheduler/rozarpayUPImandate/ccsi_mandate_pg';
  // public static pgclUPICallbackURL="https://payment.baliconline.in/BalicPayment/ccsi/pgclUPIResponseHandler.jsp";
  // public static pgclNACHCallbackURL="https://payment.baliconline.in/BalicPayment/ccsi/pgclNACHResponseHandler.jsp";
  // public static pgclCCSICallbackURL="https://payment.baliconline.in/BalicPayment/ccsi/pgclCCSIResponseHandler.jsp";

//uat 
   public static RAZORPY_KEY = 'rzp_test_9OoZbJ3ubvV328'; //uat
   public static createCustomer  = 'https://balicuat2.bajajallianzlife.com/BackOfficeScheduler/rozarpaymandate/createcustomer';
   public static saveMandateSign= 'https://balicuat2.bajajallianzlife.com/BackOfficeScheduler/rozarpaymandate/mandatesignature';
   public static downTimeUrl = "https://balicuat2.bajajallianzlife.com/BackOfficeScheduler/util/mandate_downtime";
   public static vendorType = 'https://balicuat2.bajajallianzlife.com/BackOfficeScheduler/util/mandate_pg';
   public static createCustomerUPI  = 'https://balicuat2.bajajallianzlife.com/BackOfficeScheduler/rozarpayUPImandate/createcustomerupi';
   public static saveMandateSignUPI= 'https://balicuat2.bajajallianzlife.com/BackOfficeScheduler/rozarpayUPImandate/mandatesignatureupi';
 
   
  //  public static validateUPIAgent = "https://balicuat2.bajajallianzlife.com/CCSI/mandate/validateAgentCode";
  //  public static validateSISOExtisting = "https://balicuat2.bajajallianzlife.com/CCSI/mandate/validateSISOExisting";
  //  public static vendorTypeUPI = 'https://balicuat2.bajajallianzlife.com/BackOfficeScheduler/rozarpayUPImandate/upi_mandate_pg';
  //  public static vendorTypeNACH = 'https://balicuat2.bajajallianzlife.com/BackOfficeScheduler/rozarpayUPImandate/nach_mandate_pg';
  //  public static vendorTypeCCSI = 'https://balicuat2.bajajallianzlife.com/BackOfficeScheduler/rozarpayUPImandate/ccsi_mandate_pg';
  //  public static pgclUPICallbackURL="https://balicuat2.bajajallianzlife.com/BalicPayment/ccsi/pgclUPIResponseHandler.jsp";
  //  public static pgclNACHCallbackURL="https://balicuat2.bajajallianzlife.com/BalicPayment/ccsi/pgclNACHResponseHandler.jsp";
  //  public static pgclCCSICallbackURL="https://balicuat2.bajajallianzlife.com/BalicPayment/ccsi/pgclCCSIResponseHandler.jsp";
  //  public static NRIccsiCallbackURL="https://balicuat2.bajajallianzlife.com/BalicPayment/ccsi/ccsiNRIResponseHandler.jsp";
  //  public static renPayModeChange = "https://balicuat2.bajajallianzlife.com/BackOfficeScheduler/util/updatedPayMode"
  //  public static ccsi='https://balicuat2.bajajallianzlife.com/BalicPayment/ccsi/PG.jsp';
  //  public static NRIccsi="https://balicuat2.bajajallianzlife.com/CCSI/initiate/payment";


   //UAT-4
   public static ccsi='https://balicuat2.bajajallianzlife.com/BalicPayment/ccsi/PG.jsp';
   public static validateUPIAgent = "https://balicuat4.bajajallianzlife.com/CCSI/mandate/validateAgentCode";
   public static validateSISOExtisting = "https://balicuat4.bajajallianzlife.com/CCSI/mandate/validateSISOExisting";
   public static vendorTypeUPI = 'https://balicuat4.bajajallianzlife.com/BackOfficeScheduler/rozarpayUPImandate/upi_mandate_pg';
   public static vendorTypeNACH = 'https://balicuat4.bajajallianzlife.com/BackOfficeScheduler/rozarpayUPImandate/nach_mandate_pg';
   public static vendorTypeCCSI = 'https://balicuat4.bajajallianzlife.com/BackOfficeScheduler/rozarpayUPImandate/ccsi_mandate_pg';
   public static pgclUPICallbackURL="https://balicuat4.bajajallianzlife.com/BalicPayment/ccsi/pgclUPIResponseHandler.jsp";
   public static pgclNACHCallbackURL="https://balicuat4.bajajallianzlife.com/BalicPayment/ccsi/pgclNACHResponseHandler.jsp";
   public static pgclCCSICallbackURL="https://balicuat4.bajajallianzlife.com/BalicPayment/ccsi/pgclCCSIResponseHandler.jsp";
   public static NRIccsiCallbackURL="https://balicuat4.bajajallianzlife.com/BalicPayment/ccsi/ccsiNRIResponseHandler.jsp";
   public static renPayModeChange = "https://balicuat4.bajajallianzlife.com/BackOfficeScheduler/util/updatedPayMode"
   public static NRIccsi="https://balicuat4.bajajallianzlife.com/CCSI/initiate/payment";

 
  // set new customer data
  public static setNewCustomerData = 'OnlineCustomerPortal/ws/login/azbj_emandate_standalon_logs';

  // set existing customer data
  public static setExistingCustomerData = 'OnlineCustomerPortal/ws/login/azbj_emandate_standalon_logs';

  // getAlldata for existing cutomer
  public static getAllData = 'OnlineCustomerPortal/ws/Renewal/azbj_validate_online_renewal';

  // Generic Link for new cutomer
  public static getdataGenericLink = 'OnlineCustomerPortal/ws/Prelogin/azbj_partners_mandate_reg';

  //get unique application id
  public static getUniqueAppid = 'OnlineCustomerPortal/ws/Prelogin/azbj_return_unique_id';

  // get policy details
  public static getPolicyDetails = 'OnlineCustomerPortal/ws/Renewal/azbj_validate_online_renewal';

  // get policy details
   public static getFetchAutoData = 'OnlineCustomerPortal/ws/Prelogin/azbj_fetch_auto_data';

  //encrypt_decrypt values
  public static getEncryptData = 'FinancialUWAssistWS/encrypt_decrypt';

  public static nginUrl = "CustomerPortal/OpenLinkTest/index.html#/";
  /* CCSI,EMANDATE,ENACH Redirection Links*/

 

  

//* by dhiraj
public static emandate='CustomerPortal/emandate/GetClientData.jsp'; //UAT
// public static ccsi='BalicPayment_preprod/ccsi/payment_form.jsp';
public static enach='CustomerPortal/enach/GetClientData.jsp';
public static return_url_ccsi='CustomerPortal/policy/CCSIRegistation.do'; // ccsi return link for existing customer
public static upiMandate='CustomerPortal/UPIMandate/GetClientData.jsp';
public static checkPolicy = "DocumentKycAPI/MandateService/application_routing_info"
//  // public static ccsi='https://balicuat.bajajallianz.com/BalicPaymentCCSI/ccsi/payment_form.jsp';





  /*Preprod New 22-04-200*/
//   public static emandate='https://bajajuat.bajajallianz.com/CustomerPortal/emandate/GetClientData.jsp'; //UAT
// //  // public static ccsi='https://balicuat.bajajallianz.com/BalicPaymentCCSI/ccsi/payment_form.jsp';
//   public static ccsi='https://bajajuat.bajajallianz.com/BalicPayment_preprod/ccsi/payment_form.jsp';
//   public static enach='https://bajajuat.bajajallianz.com/CustomerPortal/enach/GetClientData.jsp';
//   public static return_url_ccsi='https://bajajuat.bajajallianz.com/CustomerPortal/policy/CCSIRegistation.do'; // ccsi return link for existing customer
//   public static upiMandate='https://bajajuat.bajajallianz.com/CustomerPortal/UPIMandate/GetClientData.jsp';
//   public static checkPolicy = "https://bajajuat.bajajallianz.com/DocumentKycAPI/MandateService/application_routing_info"

  /*UAT 6*/
  //  public static upiMandate='https://balicuat.bajajallianz.com/CustomerPortal/UPIMandate/GetClientData.jsp'
  //  public static emandate='https://balicuat.bajajallianz.com/CustomerPortal/emandate/GetClientData.jsp'; //UAT
  //  public static ccsi='https://balicuat5.bajajallianz.com/BalicPayment/ccsi/payment_form.jsp'; // oldone
  //  public static ccsi='https://balicuat.bajajallianz.com/BalicPaymentCCSI/ccsi/payment_form.jsp';
  //  public static enach='https://balicuat.bajajallianz.com/CustomerPortal/enach/GetClientData.jsp';
  //  public static return_url_ccsi='https://balicuat.bajajallianz.com/CustomerPortal/policy/CCSIRegistation.do';// ccsi return link for existing customer
  //  public static checkPolicy = "https://balicuat.bajajallianz.com/DocumentKycAPI/MandateService/application_routing_info";


   /*UAT 1,2,3,4,5*/
  //  public static emandate='https://balicuat2.bajajallianzlife.com/CustomerPortal/emandate/GetClientData.jsp'; //UAT
  //  //public static ccsi='https://balicuat5.bajajallianz.com/BalicPayment/ccsi/payment_form.jsp'; // oldone
  //  public static ccsi='https://balicuat2.bajajallianzlife.com/BalicPaymentCCSI/ccsi/payment_form.jsp';
  //  public static enach='https://balicuat2.bajajallianzlife.com/CustomerPortal/enach/GetClientData.jsp';
  //  public static return_url_ccsi='https://balicuat2.bajajallianzlife.com/CustomerPortal/policy/CCSIRegistation.do';// ccsi return link for existing customer
  //  public static upiMandate='https://balicuat2.bajajallianz.com/CustomerPortal/UPIMandate/GetClientData.jsp'
  //  public static checkPolicy = "https://balicuat2.bajajallianzlife.com/DocumentKycAPI/MandateService/application_routing_info"
  /*production*/
    // public static ccsi = 'https://payment.baliconline.in/BalicPayment/ccsi/payment_form.jsp';
    // public static emandate = 'https://bajajallianzlifeonline.co.in/CustomerPortal/emandate/GetClientData.jsp';
    // public static enach = 'https://bajajallianzlifeonline.co.in/CustomerPortal/enach/GetClientData.jsp';
    // public static return_url_ccsi = 'https://bajajallianzlifeonline.co.in/CustomerPortal/policy/CCSIRegistation.do';// ccsi return link for existing customer
    // public static upiMandate='https://bajajallianzlifeonline.co.in/CustomerPortal/UPIMandate/GetClientData.jsp'
    // public static checkPolicy = "https://bajajallianzlifeonline.co.in/DocumentKycAPI/MandateService/application_routing_info"
  /*prepod*/
  //for Prepod Use UAT links for emandadate & enach.
  // public static emandate='https://balicuat.bajajallianz.com/CustomerPortal/emandate/GetClientData.jsp';
  // public static ccsi = 'http://10.3.4.38/BalicPayment/ccsi/payment_form.jsp';//prepod
  // public static enach='https://balicuat.bajajallianz.com/CustomerPortal/enach/GetClientData.jsp';
  // public static return_url_ccsi='http://10.3.4.38/CustomerPortal/policy/CCSIRegistation.do' ;// ccsi return link for both existing customer
}

/* for generic link */
/*p_user_dtls.stringval1:=v_policyholdername;
    p_user_dtls.stringval2:=v_premium;  /*original value
    p_user_dtls.stringval3:=v_mobile_no;
    p_user_dtls.stringval4:=v_email;
    p_user_dtls.stringval5:=v_ren_pay_mode;
    p_user_dtls.stringval6:=v_start_date;
    p_user_dtls.stringval7:=v_end_date;
    p_user_dtls.stringval8:=v_maxamount;  /* calculated value
    */
   //http://localhost:4200/#/?autopay_mandate_type=ENACH
  //http://localhost:4200/#/?appl_no=5948995292
/*http://localhost:4200/#/?appl_no=6067787523 */  // ccsi
/*http://localhost:4200/#/?appl_no=5914985509 */
// [‎03-‎03-‎2020 15:23] Aishwarya Kanse(Outsource-Simplycity Creations pvt ltd)/Pune/IT/Life:
//https://balicuat.bajajallianz.com/CustomerPortal/OpenLink/index.html#/?appl_no=6067762092
// https://balicuat.bajajallianz.com/CustomerPortal/OpenLink/index.html#/?appl_no=5948840867   :Enach
// https://balicuat.bajajallianz.com/CustomerPortal/OpenLink/index.html#/?appl_no=5914900496
// https://balicuat.bajajallianz.com/CustomerPortal/OpenLink/index.html#/?appl_no=5948995292   :Emandate
// https://balicuat.bajajallianz.com/CustomerPortal/OpenLink/index.html#/?appl_no=5948948439
//https://bajajuat.bajajallianz.com/CustomerPortal/OpenLink/index.html#/?appl_no=5914985509
// [‎03-‎03-‎2020 16:29] Aishwarya Kanse(Outsource-Simplycity Creations pvt ltd)/Pune/IT/Life:
//https://balicuat.bajajallianz.com/CustomerPortal/OpenLink/index.html#/?appl_no=5948995292
//http://10.3.4.95/CustomerPortal/OpenLink/index.html#/?appl_no=6095493219
//https://balicuat.bajajallianz.com/CustomerPortal/OpenLink/index.html#/?autopay_mandate_type=ENACH
//http://localhost:4200/#/?autopay_mandate_type=CCSI


